import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
const fetchWorkflow = ({
  workflowId
}) => {
  return http.get(`automationplatform/v1/flows/${workflowId}`);
};
const FETCH_WORKFLOW_QUERY = registerQuery({
  fieldName: 'workflow',
  args: ['workflowId'],
  fetcher: fetchWorkflow
});
export const useMacroSteps = selectedMacro => {
  var _data$workflow;
  const workflowId = selectedMacro === null || selectedMacro === void 0 ? void 0 : selectedMacro.workflowId;
  const {
    data,
    loading,
    error
  } = useQuery(FETCH_WORKFLOW_QUERY, {
    skip: !workflowId,
    variables: {
      workflowId: workflowId
    }
  });
  const workflowName = data === null || data === void 0 || (_data$workflow = data.workflow) === null || _data$workflow === void 0 ? void 0 : _data$workflow.name;
  return {
    workflowName,
    loading,
    error
  };
};